<template>
	<div class="basis-page-cls">
        <section class="basis-cls_filter">
			<table-search :filterHeader="filterHeader" :defaultQuery="listQuery" @filterSearch="filterSearch" />
        </section>
        <section class="basis-cls_table">
            <div class="table">
				<table-pagination
                    pagination
                    :data="list"
                    :column="column"
                    :total="total"
                    :page.sync="listQuery.pageNumber"
                    :limit.sync="listQuery.pageSize"
					@selection-change="handleSelectionChange"
                    @pagination="getList" />
            </div>
        </section>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EnumMixin } from "utils/mixins";
import { sift_query_list } from 'utils/sift';
export default {
	props: ['subbrandId'],
	name: 'CustomerPageIndex',
	mixins: [EnumMixin],
	computed: {
        ...mapGetters([
			'userInfo',  
			'subBrandList',
			'channelList',
			'isShowPhone'
		])
    },
	data() {
		return {
            column: [
				{ label: '选择', prop: 'selection', type: 'selection' ,align:'left' },
				{
                    label: '所属渠道',
                    minWidth: 100,
                    render: (h, scope) => {
                        return <span>{this.getChannelStatus(scope.row.channel)}</span>
                    }
                },
				{ label: '客户ID', prop: 'customerId', minWidth: 180 },
				{ label: '客户姓', prop: 'lastName', minWidth: 120 },
				{ label: '客户名', prop: 'firstName', minWidth: 120 },
				{
                    label: '电话号码',
                    minWidth: 150,
                    render: (h, scope) => {
                        return <span>{this.isShowPhone ? scope.row.phoneNumber : this.hiddenPhone(scope.row.phoneNumber)}</span>
                    }
                },
				{ label: '邮箱', prop: 'emailAddress', minWidth: 120 },
            ],
			filterHeader: [
				{ label: '电话号码', model: 'phoneNumber', type: 'input', default: '', placeholder: '请输入电话号码' },
				{ label: '邮箱', model: 'emailAddress', type: 'input', default: '', placeholder: '请输入邮箱' },
				{ label: '客户姓', model: 'lastName', type: 'input', default: '', placeholder: '请输入客户姓' },
				{ label: '客户名', model: 'firstName', type: 'input', default: '', placeholder: '请输入客户名' },
				{ label: '客户ID', model: 'customerId', type: 'input', default: '', placeholder: '请输入客户ID' },
				{ label: '子品牌', model: 'subBrand', type: 'select', default: '', list: [] },
				{ label: '所属渠道', model: 'channel', type: 'select', default: '', list: [] },
			],
			listQuery: {
				pageSize: 10,
                pageNumber: 1,
				brand: '',
				subBrand: '',
				channel: '',
				lastName: '',
				firstName: '',
				phoneNumber: '',
				customerId: '',
				emailAddress: ''
            },
			total: 0,
			list: [],
		}
    },
	created() {
		this.getDetailInfo();
		this.filterHeader[5]['list'] = this.subBrandList;
		this.filterHeader[6]['list'] = this.channelList;
		this.listQuery.subBrand = this.subbrandId;
		if(Object.keys(sift_query_list(this.listQuery)).length > 3) {
			this.getList();
		}
	},
	methods: {
		getList() {
			this.listQuery.brand = this.userInfo.brandIdentify;
			this.$api.apiPostCustomerList(this.listQuery).then(response => {
				if(response.errcode != 0) return;
				this.list = response.data;
				this.total = parseInt(response.total);
			});
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		getDetailInfo() {
			this.$api.apiQueryTabColumn({brand: this.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) return;
				const data = response.data;
				for(let i = 4; i < data.length; i++) {
					if(data[i]?.displayMode === 'input' && data[i]?.listQuery === 'Y') {
						this.filterHeader.push({
							label: data[i]?.columnName, model: data[i]?.columnKey, type: 'input', default: '', placeholder: `请输入${data[i]?.columnName}`
						});
					}
				}
			});
		},
        filterSearch(query) {
			this.listQuery = Object.assign(this.listQuery, query);
			if(this.listQuery.phoneNumber || this.listQuery.customerId || this.listQuery.emailAddress || this.listQuery.lastName || this.listQuery.firstName) {
				this.getList();
			} else {
				this.$message.error('请选择查询条件');
			}
		},
		handleSelectionChange(row) {
			console.log(row)
			this.$emit('onEmitCustomerData', row[0]);
		},
    }
}
</script>